import { StyleSheet } from 'react-native';
import { neutrals } from 'src/theme/colors';

export const styles = StyleSheet.create({
  bottomSheet: {
    shadowColor: neutrals.black,
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 82,
    borderRadius: 22,
  },
  contentContainer: {
    flex: 1,
  },
  bottomSheetContainer: {
    paddingHorizontal: 10,
    zIndex: 3,
    paddingBottom: 10,
  },
  overlay: {
    backgroundColor: neutrals.black,
    opacity: 0.5,
    width: '100%',
    height: '100%',
    position: 'absolute',
  },
  dragIndicator: {
    width: 32,
  },
  noDragIndicator: {
    width: 0,
  },
});
